import { Link } from "react-router-dom";
import { BadgeCheck, Crown, MapPin } from "lucide-react";
import { imgSrc, ROLE_LABEL } from "@/lib/api";

export const VerifiedBadge = ({ status }) =>
  status === "verified" ? (
    <span data-testid="badge-verified" className="inline-flex items-center gap-1 rounded-full bg-white/10 px-2 py-0.5 text-[10px] uppercase tracking-widest text-white">
      <BadgeCheck className="h-3 w-3 text-red-500" />ID Verified
    </span>
  ) : null;

export const TierBadge = ({ tier }) =>
  tier === "vip" ? (
    <span data-testid="badge-vip" className="inline-flex items-center gap-1 rounded-full border border-amber-500/40 bg-amber-500/10 px-2 py-0.5 text-[10px] uppercase tracking-widest text-amber-300">
      <Crown className="h-3 w-3" />VIP
    </span>
  ) : tier === "member" ? (
    <span className="rounded-full border border-white/15 px-2 py-0.5 text-[10px] uppercase tracking-widest text-zinc-300">Member</span>
  ) : null;

export function MemberCard({ m, i = 0 }) {
  return (
    <Link to={`/members/${m.id}`} data-testid={`member-card-${m.id}`} style={{ animationDelay: `${i * 60}ms` }}
      className="card-lux rise group relative block overflow-hidden hover:-translate-y-1">
      <div className="aspect-[3/4] overflow-hidden">
        <img src={imgSrc(m.photo)} alt={m.name} className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
      </div>
      <div className="absolute inset-0 bg-gradient-to-t from-black via-black/20 to-transparent" />
      <div className="absolute left-3 top-3 flex gap-1.5"><TierBadge tier={m.membership} /><VerifiedBadge status={m.id_status} /></div>
      <div className="absolute bottom-0 left-0 right-0 p-4">
        <p className="eyebrow mb-1 !text-red-400">{ROLE_LABEL[m.role_type]}</p>
        <h3 className="font-display text-2xl">{m.name}{m.age ? `, ${m.age}` : ""}</h3>
        <p className="mt-1 flex items-center gap-1 text-xs text-zinc-400"><MapPin className="h-3 w-3" />{[m.city, m.country].filter(Boolean).join(", ") || "Worldwide"}</p>
      </div>
    </Link>
  );
}
